module.exports = __webpack_public_path__ + "img/li.ba2593c1.png";